/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

const arrow = (color: string) => `<?xml version="1.0" encoding="UTF-8"?>
<svg width="7px" height="12px" viewBox="0 0 7 12"
version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->

    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Coriolis" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
     stroke-linecap="round" stroke-linejoin="round">
        <g id="202-Replica-Executions" transform="translate(-1197.000000, -194.000000)" stroke="${color}">
            <g id="Icon/Chevron/Grey"
            transform="translate(1200.000000, 200.000000) rotate(-90.000000)
            translate(-1200.000000, -200.000000) translate(1192.000000, 192.000000)">
                <polyline id="Rectangle-Copy" transform="translate(8.000000, 5.500000)
                rotate(-315.000000) translate(-8.000000, -5.500000) "
                points="11.8890873 1.6109127 11.8890873 9.3890873 4.1109127 9.3890873"></polyline>
            </g>
        </g>
    </g>
</svg>`;

export default arrow;
